<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'
import {setChinaMap} from "@/air/utils/china"

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '320px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      setChinaMap(this.$echarts)
      let dataMap = {}, seriesData = []
      let sum = 0, percentList = []
      for (let item of chartData.v_92740006) {
        dataMap[item.detailKey] = item.detailValue
        sum += Number(item.detailValue)
      }
      for (let item of chartData.nativePlace) {
        const name = item.codeitemname.replace('市', '').replace('省', '').replace('自治区', '').replace('壮族', '').replace('回族', '').replace('维吾尔', '').replace('特别行政区', '')
        const value = dataMap[item.codetreeid] || 0
        seriesData.push({
          name,
          value
        })
        const percent = (Number(value) / sum) * 100
        percentList.push({
          name,
          percent: percent.toFixed(2)
        })
      }
      this.chart.setOption({
        backgroundColor: '#FFFFFF',
        title: {
          text: '',
          subtext: '',
          y: '5%',
          x:'center'
        },
        tooltip : {
          trigger: 'item'
        },
        //左侧小导航图标
        visualMap: {
          show : false,
          x: 'left',
          y: 'center',
          pieces: [{
            gte: 500,
            label: ">=500",
            color: "#41A7AD"
          }, {
            gte: 100,
            lte: 499,
            label: "100-499",
            color: "#71C4D2"
          }, {
            gte: 10,
            lte: 99,
            label: "10-99",
            color: "#A8D7E4"
          }, {
            gte: 0,
            lte: 9,
            label: "0-9",
            color: "#CDE8F0"
          }],
          color: ['#CDE8F0', '#A8D7E4', '#71C4D2','#41A7AD']
        },
        //配置属性
        series: [{
          name: '员工籍贯统计',
          type: 'map',
          mapType: 'china',
          // roam: true,  // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
          label: {
            normal: {
              show: false  //省份名称
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            borderColor: '#FFFFFF',
            borderWidth: 1
          },
          data: seriesData
        }]
      })
      // 百分比按倒序排列
      percentList.sort((a, b) => b.percent - a.percent)
      this.$emit('sort-percent', percentList)
    }
  }
}
</script>
